// Without a browser every question here answers "no": a server render draws the
// neutral variant and the real answer arrives after mount.
// Guarded on `window`, not `navigator`: Node has had a global `navigator` since 21,
// so a server render reaches a real object here and answers from it.
function getUserAgent() {
    if (typeof window === 'undefined') return ''

    return navigator.userAgent || navigator.vendor || window.opera || ''
}

function getPlatform() {
    if (typeof window === 'undefined') return ''

    return navigator.platform || ''
}

export function isInAppBrowser() {
    const inAppPatterns = [
        /FBAN|FBAV/,           // Facebook
        /Instagram/,           // Instagram
        /Twitter/,             // Twitter
        /TikTok/,              // TikTok
        /LinkedInApp/,         // LinkedIn
        /Snapchat/,            // Snapchat
        /WhatsApp/,            // WhatsApp
        /MicroMessenger/       // WeChat
    ]

    return inAppPatterns.some(pattern => pattern.test(getUserAgent()))
}

export function isIos() {
    return /iPad|iPhone|iPod/.test(getUserAgent()) && !window.MSStream
}

export function isIosBrowser() {
    return isIos() && !navigator.standalone
}

export function isMac() {
    return /Mac|iPhone|iPad|iPod/.test(getPlatform())
}

export function isWindows() {
    return /Win/.test(getPlatform())
}
